module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_89_4_3.fefcbdc0.png";